import { DataSourceChangeConfirmModal } from './data-source-change-confirm-modal';
import { useFormikContext } from 'formik';
import { UpdateConfigDialogFormValues } from '../../dto';
import { DataSourceConfig } from '../../../data-source-config';
import { Alert, Button, Grid, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import { DataSourceDto, GenericTableConfigDto, GenericTableConfigPatchDto } from 'inside-fifa/api/generic-tables/dto';

type DataSourceManagerProps = {
    onSubmit: (data: GenericTableConfigPatchDto) => Promise<void>;
    initialConfig: GenericTableConfigDto;
};

export const DataSourceManager = ({ initialConfig, onSubmit }: DataSourceManagerProps) => {
    const { values, dirty, isSubmitting } = useFormikContext<UpdateConfigDialogFormValues>();
    const [newDataSource, setNewDataSource] = useState<DataSourceDto | null>(null);
    const [isDataSourceConfirmModalOpened, setIsDataSourceConfirmModalOpened] = useState(false);

    return (
        <>
            <DataSourceChangeConfirmModal
                newDataSource={isDataSourceConfirmModalOpened ? newDataSource : null}
                pendingChanges={dirty}
                onSubmit={(data) =>
                    onSubmit({ ...data, modifiedTimestamp: values.modifiedTimestamp }).then(() =>
                        setIsDataSourceConfirmModalOpened(false),
                    )
                }
                onCancel={() => {
                    setIsDataSourceConfirmModalOpened(false);
                }}
            />
            <Stack spacing={2}>
                <DataSourceConfig
                    value={newDataSource ?? initialConfig.dataSource}
                    onChange={setNewDataSource}
                    disabled={isSubmitting || (dirty && !newDataSource)}
                />
                {dirty && (
                    <Grid item>
                        <Alert severity="error">
                            <FormattedMessage id="inside-fifa.generic-tables.data-source-change-note-on-pending-changes" />
                        </Alert>
                    </Grid>
                )}
                {newDataSource && (
                    <Grid item>
                        <Alert severity="warning">
                            <FormattedMessage id="inside-fifa.generic-tables.data-source-change-note" />
                        </Alert>
                    </Grid>
                )}
                <Grid item xs={12} rowGap={3}>
                    <Stack spacing={1} direction="row">
                        <Button
                            onClick={() => setIsDataSourceConfirmModalOpened(true)}
                            disabled={!newDataSource}
                            variant="contained"
                            color="success"
                        >
                            <FormattedMessage id="inside-fifa.generic-tables.data-source-change-save" />
                        </Button>
                        <Button
                            onClick={() => setNewDataSource(null)}
                            disabled={!newDataSource}
                            variant="contained"
                            color="error"
                        >
                            <FormattedMessage id="inside-fifa.generic-tables.data-source-change-revert" />
                        </Button>
                    </Stack>
                </Grid>
            </Stack>
        </>
    );
};
